import {
  BulkLoadedType,
  BulkRemoveType,
  ErrorType,
  InvalidateType,
  LoadedMoreType,
  LoadedType,
  type QueryParams,
  RequestMoreType,
  RequestType,
} from 'common/actions/ideaActivityQueries';

import queryReducerFactory, { type QueriesState, type QueryState } from './queryReducerFactory';

export { defaultState } from './queryReducerFactory';

import type { IdeaActivity } from 'common/api/endpoints/ideaActivity';

export type IdeaActivityQueriesState = QueriesState<IdeaActivity, QueryParams>;
export type IdeaActivityQueryState = QueryState<IdeaActivity, QueryParams> | undefined;

export default queryReducerFactory<IdeaActivity, QueryParams>({
  bulkLoadedType: BulkLoadedType,
  bulkRemoveType: BulkRemoveType,
  errorType: ErrorType,
  invalidateType: InvalidateType,
  loadedMoreType: LoadedMoreType,
  loadedType: LoadedType,
  requestMoreType: RequestMoreType,
  requestType: RequestType,
});
